import { NftType } from 'connectors/constants';

export const REVENUE_FIELD = {
  KEYWORD: 'keyword',
  FROM: 'from',
  UNTIL: 'until',
  NFT_TYPE: 'nftType',
  TYPE: 'saleOrderType',
  PAGE: 'page',
  LIMIT: 'limit',
  SORT: 'sort',
  FIELD: 'field',
  ORDER: 'order',
  SELL: 'sell',
  RESELL: 'resell',
};

export const REVENUE_FIELD_SORTER = {
  DEFAULT: 'default',
  CREATED_AT: 'createdAt',
  NFT_ID: 'nft.id',
  NFT_NAME: 'nft.name',
  QUANTITY: 'quantity',
  UNIT_PRICE: 'unitPriceBNB',
  SUB_TOTAL: 'subTotal',
  REVENUE: 'revenue',
};

export const REVENUE_TABS = {
  PRIMARY: {
    key: 'PRIMARY',
    label: 'revenue_management.txt_primary',
  },
  SECONDARY: {
    key: 'SECONDARY',
    label: 'revenue_management.txt_secondary',
  },
};

export const CURRENCY = 'BNB';

export const REVENUE_TYPE = [
  {
    name: 'revenue_management.txt_all',
    value: null,
  },
  {
    name: 'revenue_management.txt_hero',
    value: NftType.WEAPON,
  },
  {
    name: 'revenue_management.txt_item',
    value: NftType.LAND,
  },
];

export const COLUMN = {
  NO: 'no',
  SELLER: 'fromAddress',
  SALE_DATE: 'createdAt',
  BUYER: 'toAddress',
  TYPE: 'nft.token.standard',
  QUANTITY: 'quantity',
  NFT_ID: 'nft.id',
  PRICE: 'saleOrder.unitPrice',
  NFT_NAME: 'nft.name',
  SUBTOTAL: 'subTotal',
  ROYALTIES: 'revenue',
  TOKEN_ID: 'saleOrder.tokenId',
  ACTIONS: 'actions',
};

export const REVENUE_DECIMAL_SCALE = 2;

export const FORMAT_EXPORT_DATA_DATE = 'DDMMYY_HHmmss';